import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { NotificationHub } from '@nef/core';

import { downloadIssuerDocument } from '../../redux/document/actions';
import { AppDispatch } from '../../app/store';
import NasdaqLoader from '../../components/common/NasdaqLoader';

const DocDownload = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { documentId } = useParams<{ documentId: string }>();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (documentId) {
      setIsLoading(true)
      dispatch(downloadIssuerDocument({ documentId })).unwrap()
        .then((response: any) => {
          const url = URL.createObjectURL(response?.data);
          setIsLoading(false)
          window.open(url, '_self');
        })
        .catch(error => {
          setIsLoading(false)
          NotificationHub.send("danger", `${error.message}`)
        })
    }
  }, [documentId]);

  return (<>
    {isLoading && <NasdaqLoader />}
    <NotificationHub />
  </>);
}

export default DocDownload